export const notificationConstant = {
    GET_NOTIFICATION_SUCCESS:"GET_NOTIFICATION_SUCCESS",
    GET_NOTIFICATION_FAILURE:"GET_NOTIFICATION_FAILURE",  
  };
  